import BaseModel from './BaseModel';

export default class ProjectPartIndex extends BaseModel {
  constructor({id, designation}) {
    super(id, designation);
  }
  static get fkName() {
    return 'project_part_index_id';
  }
  static get apiRoute() {
    return 'project_part_index';
  }
  static get listPageRoute() {
    return null;
  }
  static get detailPageRoute() {
    return null;
  }
  static get createInitColumns() {
    return {};
  }

  static get joinAttrsKey() {
    return ['designation'];
  }

  static get orderKey() {
    return 'id';
  }
  get fkName() {
    return ProjectPartIndex.fkName;
  }
  get apiRoute() {
    return ProjectPartIndex.apiRoute;
  }
  get detailPageRoute() {
    return ProjectPartIndex.detailPageRoute;
  }
  get listPageRoute() {
    return ProjectPartIndex.listPageRoute;
  }
  get createInitColumns() {
    return ProjectPartIndex.createInitColumns;
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation']);
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['designation']);
  }
  static get allAttributes() {
    return [this.DESIGNATION_ATTRIBUTE()];
  }
}
